import { forwardRef } from 'react';
import { Control, Controller } from 'react-hook-form';

import { TextInput } from '@/components';
import { InputType } from '@/components/inputs/TextInput';

export interface FormTextInputProps {
  control: Control<any>;
  name: string;
  placeholder: string;
  type?: InputType;
  disabled?: boolean;
  required?: boolean;
  autoFocus?: boolean;
  onBlur?: () => void;
  hideLabel?: boolean;
  autoComplete?: string;
  endAdornment?: React.ReactNode;
  startAdornment?: React.ReactNode;
  onChangeValue?: (value: string) => string;
}

const FormTextInput = forwardRef<HTMLInputElement, FormTextInputProps>(
  (
    {
      control,
      name,
      placeholder,
      type,
      disabled = false,
      required = false,
      autoFocus = false,
      onBlur,
      hideLabel = false,
      autoComplete = 'off',
      endAdornment,
      startAdornment,
      onChangeValue,
    },
    ref
  ) => {
    return (
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <TextInput
            {...field}
            onChange={(value) =>
              field.onChange(
                onChangeValue ? onChangeValue(String(value)) : value
              )
            }
            ref={ref}
            type={type}
            placeholder={placeholder}
            errorInfo={error?.message}
            autoFocus={autoFocus}
            error={!!error}
            disabled={disabled}
            required={required}
            onBlur={() => {
              field.onBlur();
              onBlur?.();
            }}
            hideLabel={hideLabel}
            autoComplete={autoComplete}
            endAdornment={endAdornment}
            startAdornment={startAdornment}
          />
        )}
      />
    );
  }
);

export default FormTextInput;
